import { frontendURL } from '../../../../helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

import ReportsWrapper from './components/ReportsWrapper.vue';
import Index from './Index.vue';

import AgentReportsIndex from './AgentReportsIndex.vue';
import InboxReportsIndex from './InboxReportsIndex.vue';
import TeamReportsIndex from './TeamReportsIndex.vue';
import LabelReportsIndex from './LabelReportsIndex.vue';

import AgentReportsShow from './AgentReportsShow.vue';
import InboxReportsShow from './InboxReportsShow.vue';
import TeamReportsShow from './TeamReportsShow.vue';
import LabelReportsShow from './LabelReportsShow.vue';

import AgentReports from './AgentReports.vue';
import InboxReports from './InboxReports.vue';
import LabelReports from './LabelReports.vue';
import TeamReports from './TeamReports.vue';

import CsatResponses from './CsatResponses.vue';
import BotReports from './BotReports.vue';
import LiveReports from './LiveReports.vue';
import SLAReports from './SLAReports.vue';

const meta = {
  featureFlag: FEATURE_FLAGS.REPORTS,
  permissions: ['administrator'],
};

const oldReportRoutes = [
  {
    path: 'agent',
    name: 'agent_reports',
    meta: { ...meta, permissions: [...meta.permissions, 'reports_agent'] },
    component: AgentReports,
  },
  {
    path: 'inboxes',
    name: 'inbox_reports',
    meta: { ...meta, permissions: [...meta.permissions, 'reports_inbox'] },
    component: InboxReports,
  },
  {
    path: 'label',
    name: 'label_reports',
    meta: { ...meta, permissions: [...meta.permissions, 'reports_label'] },
    component: LabelReports,
  },
  {
    path: 'teams',
    name: 'team_reports',
    meta: { ...meta, permissions: [...meta.permissions, 'reports_team'] },
    component: TeamReports,
  },
];

const revisedReportRoutes = [
  {
    path: 'agents_overview',
    name: 'agent_reports_index',
    meta: {
      permissions: ['administrator', 'reports_agent'],
    },
    component: AgentReportsIndex,
  },
  {
    path: 'agents/:id',
    name: 'agent_reports_show',
    meta: {
      permissions: ['administrator', 'reports_agent'],
    },
    component: AgentReportsShow,
  },

  {
    path: 'inboxes_overview',
    name: 'inbox_reports_index',
    meta: {
      permissions: ['administrator', 'reports_inbox'],
    },
    component: InboxReportsIndex,
  },
  {
    path: 'inboxes/:id',
    name: 'inbox_reports_show',
    meta: {
      permissions: ['administrator', 'reports_inbox'],
    },
    component: InboxReportsShow,
  },
  {
    path: 'teams_overview',
    name: 'team_reports_index',
    meta: {
      permissions: ['administrator', 'reports_team'],
    },
    component: TeamReportsIndex,
  },
  {
    path: 'teams/:id',
    name: 'team_reports_show',
    meta: {
      permissions: ['administrator', 'reports_team'],
    },
    component: TeamReportsShow,
  },
  {
    path: 'labels_overview',
    name: 'label_reports_index',
    meta: {
      permissions: ['administrator', 'reports_label'],
    },
    component: LabelReportsIndex,
  },
  {
    path: 'labels/:id',
    name: 'label_reports_show',
    meta: {
      permissions: ['administrator', 'reports_label'],
    },
    component: LabelReportsShow,
  },
];

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: ReportsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'account_overview_reports', params: to.params };
          },
        },
        {
          path: 'overview',
          name: 'account_overview_reports',
          meta: {
            ...meta,
            permissions: [...meta.permissions, 'reports_overview'],
          },
          component: LiveReports,
        },
        {
          path: 'conversation',
          name: 'conversation_reports',
          meta: {
            ...meta,
            permissions: [...meta.permissions, 'reports_conversation'],
          },
          component: Index,
        },
        ...oldReportRoutes,
        ...revisedReportRoutes,
        {
          path: 'sla',
          name: 'sla_reports',
          meta: { ...meta, permissions: [...meta.permissions, 'reports_sla'] },
          component: SLAReports,
        },
        {
          path: 'csat',
          name: 'csat_reports',
          meta: { ...meta, permissions: [...meta.permissions, 'reports_csat'] },
          component: CsatResponses,
        },
        {
          path: 'bot',
          name: 'bot_reports',
          meta: { ...meta, permissions: [...meta.permissions, 'reports_bot'] },
          component: BotReports,
        },
      ],
    },
  ],
};
